import type { Participant } from '@seen/core/models/patients/participant'
import { Button } from '@seen/ui'
import { IconRefresh } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import { ExternalTextLink } from '#src/components/core/index.ts'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'
import { useCrmRefresh } from '#src/components/external-links/useCrmRefresh.ts'

export function CRMLink({
  participant,
}: {
  participant: Participant
}): ReactNode {
  const { refresh, isRefreshing } = useCrmRefresh(participant.twentyLeadId)

  if (!participant.crmUrl) {
    return null
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="relative">
          <ExternalTextLink href={participant.crmUrl}>CRM</ExternalTextLink>
        </span>
      </TooltipTrigger>
      <TooltipContent className="w-max max-w-[min(30rem,90vw)]">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between gap-4">
            <div className="text-sm font-medium">CRM Sync</div>
            <Button
              variant="ghost"
              size="2xs"
              onClick={refresh}
              loading={isRefreshing}
              className="h-6 px-2 text-xs"
            >
              <IconRefresh className="size-3" />
              Sync from CRM
            </Button>
          </div>
          <div className="text-xs text-foreground-tertiary">
            Syncs participant data, notes, and attachments from CRM
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
